module.exports = __webpack_public_path__ + "static/media/people_template_v.2022.1.592f4ca8.xls";